/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line spaced-comment
// eslint-disable-line no-plusplus
// eslint-disable-next-line spaced-comment
// eslint-disable-next-line spaced-comment
import React,{useState,useCallback,useEffect} from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'
import IconButton from "@mui/material/IconButton";


import MenuIcon from "@mui/icons-material/Menu";



import BackButton from '../../components/BackButton/BackButton';
import styles from './Calendar.module.css';
import  Calendar  from '../../components/Calendar/Calendar';

import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

import LeftNav from  '../../atomicComponents/LeftNav';


function ReportNoPOPage({product}) {
  const history = useHistory();
  const [openCloseFlag, setOpenClose] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const redirectToProcessPage = () => {
    history.push('/home');
  };
  
  
  useEffect(() => {
    const isMobileDevice = /Mobi/.test(window.navigator.userAgent);
    if(isMobileDevice)
    {
      setIsMobile(isMobileDevice);
    } else {
      setIsMobile(false);

    }
   
  }, []);


  const setOpenCloseAction=()=>{
    setOpenClose(!openCloseFlag)
   
  }
 const myrender=()=>(<>
 
    <div className={styles.container} style={{ boxSizing: 'border-box' }}>
    <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>
      <BackButton
          action="Home"
          handleClick={redirectToProcessPage}
        /> 
      </div>
      <div className={styles.processHeader}>
         <div className={styles.CustomTabClass} >
          <CustomTab title="ERC Calendar" withOutCount isSelected />
        </div>
        <div className={styles.processTopbar} style={{}}>

        <UserInfoPanel
              userInfo={[
                {
                  Name: "Pratik",
                  "SAP ID": 122366,
                  "BC No": "122366",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
            </div>
</div>
   
      <Calendar redirectToProcessPage={redirectToProcessPage}/>

    </div>
  </>);

  return (
    // <LeftNav displayDrawer={(isMobile?"mobile":"desktop")} devices={isMobile} openClose={openCloseFlag} details={myrender()}/>
   
    <div className={styles.container} style={{ boxSizing: 'border-box' }}>
        <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>
{/* 
      {isMobile?<>
        <BackButton
          action="Home"
          handleClick={redirectToProcessPage}
        />
            <MenuIcon style={{color: "#2162ac"}}  onClick={()=>{setOpenCloseAction()}} />

        </>:  <BackButton
          action="Home"
          handleClick={redirectToProcessPage}
        />
      } */}
     
      </div>
      {/* <div className={styles.processHeader}>
         <div className={styles.CustomTabClass} >
          <CustomTab title="ERC Calendar" withOutCount isSelected />
        </div>
        <div className={styles.processTopbar} style={{}}>

        <UserInfoPanel
              userInfo={[
                {
                  Name: "Pratik",
                  "SAP ID": 122366,
                  "BC No": "122366",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
            </div>
</div> */}
   
      <Calendar redirectToProcessPage={redirectToProcessPage}/>

    </div>
  
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
ReportNoPOPage.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(ReportNoPOPage); 
